import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Text } from '@atlaskit/primitives/compiled';
import { JiraBanner as Banner } from '@atlassian/jira-banner/src/ui/jira-banner.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { CustomTemplateProjectBanner$key } from './__generated__/CustomTemplateProjectBanner.graphql';
import messages from './messages.tsx';

export type CustomTemplateProjectBannerProps = {
	projectFragment: CustomTemplateProjectBanner$key;
};

const isBannerSupported = () => {
	if (__SERVER__) return true;
	if (typeof window !== 'undefined') return window.__SPA__;
	return false;
};

/**
 * The Jira nav header can render legacy pages, these legacy pages are absolutely positioned
 * underneath the nav header. This means that if we render our banner in the header the nav
 * menu will be cut off. So for now we are not rendering our banner when a legacy page has been
 * selected.
 */
export const CustomTemplateProjectBanner = ({
	projectFragment,
}: CustomTemplateProjectBannerProps) => {
	const { formatMessage } = useIntl();
	const data = useFragment(
		graphql`
			fragment CustomTemplateProjectBanner on JiraProject {
				isLiveTemplate
			}
		`,
		projectFragment,
	);

	return (
		data.isLiveTemplate === true &&
		isBannerSupported() && (
			<Banner
				appearance="announcement"
				messageId="horizontal-nav.ui.content.banner"
				messageType="transactional"
			>
				<Text>{formatMessage(messages.customTemplateProjectBannerMessage)}</Text>
			</Banner>
		)
	);
};
